module.exports = __webpack_public_path__ + "static/img/close.06c70178.svg";